import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Icon } from '../../Icon/Icon.es.js';
import { useMenuContext } from '../Menu.Context/index.es.js';

const MenuIconButton = ({ icon = 'DotsVerticalSolid', variant = 'primary', label, ...props })=>{
    const [{ inputLoading, disabled, open }, { setOpen }] = useMenuContext();
    const handleClick = useCallback((event)=>{
        event.stopPropagation();
        setOpen(!open);
    }, [
        open,
        setOpen
    ]);
    return jsx(Button, {
        className: classNames('trigger-icon-button'),
        disabled: disabled,
        label: label,
        loading: inputLoading,
        onClick: handleClick,
        variant: variant,
        iconOnly: true,
        ...props,
        children: jsx(Icon, {
            name: icon,
            size: 24
        })
    });
};
MenuIconButton.displayName = 'MenuV2.IconButton';

export { MenuIconButton };
//# sourceMappingURL=Menu.IconButton.es.js.map
